import { forwardRef, LegacyRef } from "react";

const GeniusNoAccessELASvg = forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: LegacyRef<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        width="128"
        height="109"
        viewBox="0 0 128 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M42.9446 48.4062C35.4879 49.5477 30.6656 49.7418 25.3503 52.1837C18.1129 56.5902 11.093 61.6721 6.07467 68.4972C1.0563 75.3224 -1.31797 83.6072 0.741798 91.8261C3.03258 100.973 16.457 108.825 26.3966 108.825C35.2259 108.825 35.9966 108.763 44.8239 108.825H47.0059C47.0059 108.825 46.5652 98.1892 46.8933 94.1924C39.1183 92.9267 31.1413 89.5452 24.6611 85.065L27.9031 81.0837C27.9031 81.0837 27.6061 86.8121 27.8973 86.8373C37.1342 92.2609 50.3839 96.1025 58.5705 94.3826C61.1486 93.841 64.3596 93.8992 67.7492 93.8992L72.7015 95.6541V92.3995L76.0309 90.7022C76.0309 90.7022 91.7787 76.7033 87.7487 70.0761C87.7487 70.0761 78.8164 56.7586 74.0622 53.5763C72.115 52.0195 68.7024 50.9705 66.2233 50.691L49.883 48.8547L42.9446 48.4062Z"
          fill="#FF6B6B"
        />
        <path
          d="M47.0298 94.3432C47.0298 94.3432 53.5934 94.9993 53.6323 94.9934C58.3963 94.1743 63.24 93.8249 68.072 93.9569L74.3988 96.2222L71.8285 105.977L46.7852 106.701L47.0298 94.3432Z"
          fill="#A55D2B"
        />
        <path
          d="M19.9414 82.0469C28.0329 88.1518 37.5688 92.1467 47.59 94.3519C49.9448 94.8702 52.3676 95.0177 54.7671 94.7828C59.3099 94.3383 63.8274 93.7424 67.7508 93.9093C69.5136 94.4218 72.346 95.6117 74.1087 96.1242"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.3242 96.2422C70.0287 96.8711 71.7313 97.502 73.4358 98.1309"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.8308 100.525C70.8526 99.7098 68.4841 98.8925 66.6127 97.9161C66.5797 97.8171 66.5467 97.7181 66.5156 97.6172"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.7633 104.06C69.1484 103.055 66.5314 102.051 64.0077 101.049C63.8931 100.76 63.7786 100.469 63.6641 100.18"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5586 85.0208C26.6125 82.4488 28.6665 79.8767 30.7224 77.3047"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.947 80.7812C27.9217 82.5244 27.9237 85.3973 27.8984 87.1405"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.18 78.5391C48.3302 83.326 43.2574 85.1215 38.3672 84.0422"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.75 60.1641C71.4077 63.4776 74.1275 66.9135 75.2787 71.0016C76.43 75.0896 75.6146 80.0435 72.2114 82.5844L72.3687 95.3379"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.888 94.1797L46.7812 105.943"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.4783 35.6315C49.1179 35.9201 50.6811 34.825 50.9697 33.1855C51.2583 31.546 50.1631 29.983 48.5235 29.6944C46.8839 29.4058 45.3207 30.5009 45.0321 32.1404C44.7435 33.7799 45.8387 35.3429 47.4783 35.6315Z"
          fill="black"
        />
        <path
          d="M44.6374 49.4535C45.1278 46.2612 47.4378 32.2105 47.4378 32.2105C45.7059 32.5225 44.1439 32.1215 42.9503 30.8276C41.7568 29.5337 41.9198 28.8979 42.3697 27.1946C42.8189 25.4946 42.9649 24.065 44.6409 23.5284L53.5742 16.56C55.9288 15.8668 58.5533 16.1379 60.7177 17.2994C62.8821 18.4608 64.1176 18.5218 64.8397 20.8676C65.6162 25.1381 62.8563 34.8323 62.8563 34.8323C61.908 37.3919 59.5783 39.57 56.8802 39.988C56.7267 40.2404 56.0334 44.2171 56.0334 44.2171L55.0444 51.074C54.2096 51.4212 52.2225 52.1178 49.6884 51.7399C47.0677 51.3502 45.3297 50.0321 44.6452 49.4481L44.6374 49.4535Z"
          fill="#A55D2B"
        />
        <path
          d="M52.9123 21.8374C54.6023 20.6535 55.4237 18.911 54.7472 17.9454C54.0706 16.9798 52.1521 17.1568 50.4622 18.3407C48.7723 19.5246 47.9508 21.2671 48.6274 22.2327C49.304 23.1983 51.2224 23.0213 52.9123 21.8374Z"
          fill="black"
        />
        <path
          d="M44.9336 27.2656C45.6481 27.7765 46.1965 28.5138 46.4831 29.3447"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.4469 26.1225C46.5786 24.6268 42.8557 24.4385 42.2458 27.9028C41.8052 30.4052 43.9193 32.9177 47.2103 32.1712"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.6808 38.9839C52.909 40.0543 55.553 40.4277 57.8579 39.6099C58.4359 39.4049 59.0036 39.1231 59.5443 38.782C61.7296 37.4047 62.7859 35.6445 63.404 32.7337C64.0221 29.8229 65.9893 21.3591 64.3805 20.333"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.9297 25.5703C49.0367 26.4263 49.054 28.3414 47.966 29.2166C48.723 29.1181 49.5065 29.682 49.6537 30.4338C49.8008 31.1857 49.2856 32.0016 48.546 32.1952C49.1718 32.6291 49.521 33.4335 49.4126 34.1847C49.3042 34.9358 48.7423 35.6106 48.0188 35.8479"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.5247 38.9814C51.7876 41.1974 53.7452 43.0109 56.051 44.1052C56.051 44.1052 56.666 40.3793 56.7306 40.0124C54.6717 40.3043 52.5062 39.8073 50.528 38.982L50.5247 38.9814Z"
          fill="black"
        />
        <path
          d="M45.3141 33.3126C46.028 33.4382 46.7086 32.9614 46.8343 32.2476C46.96 31.5337 46.4831 30.8532 45.7692 30.7275C45.0553 30.6019 44.3747 31.0787 44.249 31.7925C44.1233 32.5064 44.6002 33.1869 45.3141 33.3126Z"
          fill="#FDE7C7"
        />
        <path
          d="M59.7434 32.0255C59.2632 31.4809 58.9477 30.7948 58.8305 30.0278C58.6987 29.1696 58.8529 28.2936 59.2139 27.5017C59.4313 27.0219 59.6851 26.6065 59.9976 26.2253C61.3142 24.6132 63.8056 24.8848 64.4912 26.4505"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.887 24.1811C56.3739 23.1343 54.2311 23.4184 52.9332 24.5566"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.0966 29.695C62.5568 29.776 63.0142 29.3621 63.1183 28.7706C63.2224 28.1791 62.9339 27.6339 62.4737 27.5529C62.0136 27.4719 61.5562 27.8858 61.4521 28.4773C61.3479 29.0688 61.6365 29.614 62.0966 29.695Z"
          fill="black"
        />
        <path
          d="M52.5122 30.1907L56.3502 32.9009C56.3502 32.9009 54.5611 34.2151 53.1789 33.3345C52.3328 32.797 51.7043 31.2754 52.5149 30.1946L52.5122 30.1907Z"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.4443 28.5309C55.9044 28.6119 56.3618 28.198 56.4659 27.6065C56.5701 27.015 56.2815 26.4698 55.8214 26.3888C55.3613 26.3078 54.9039 26.7217 54.7997 27.3132C54.6956 27.9048 54.9842 28.4499 55.4443 28.5309Z"
          fill="black"
        />
        <path
          d="M56.7812 39.8906L55.1173 50.5139"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.9348 20.8668C65.4028 20.0869 66.3324 19.9369 67.0039 20.0722C67.6754 20.2074 68.1809 20.8792 68.1725 21.5661C68.164 22.2531 67.6704 22.8887 67.0231 23.119C67.3985 22.8068 68.0303 22.8771 68.3303 23.2639C68.6303 23.6507 68.5402 24.279 68.1418 24.5667C68.8831 24.0735 69.9838 24.2298 70.5593 24.9104C71.1348 25.5911 71.1026 26.7033 70.4913 27.3489"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4207 11.2543C54.9971 11.233 55.4983 10.6703 55.4528 10.0965C55.4072 9.52278 54.8305 9.04296 54.2565 9.10892C55.4042 8.82358 56.4271 7.89256 56.5955 6.72256C56.764 5.55255 55.8855 4.26982 54.7051 4.19838"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.3416 3.83628C41.7596 3.13403 40.7186 2.85195 39.8625 3.16478C39.0065 3.4776 38.3935 4.36489 38.4062 5.2805C37.8611 4.89146 37.1208 4.79865 36.4949 5.04293C35.8691 5.28722 35.3871 5.85674 35.2481 6.5105"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.5967 25.1069C47.1945 25.8858 47.3147 25.4741 47.3248 26.4233C47.8553 26.7791 48.5838 26.5325 48.7858 25.9273C49.1313 24.8941 49.5568 23.6773 50.2752 22.0554C50.8798 20.6929 52.1184 19.6976 53.5888 19.4384C57.3454 18.7772 61.5991 19.1068 65.0904 21.289C65.3097 15.803 61.5189 12.5729 57.172 11.0886C52.8251 9.60439 47.6835 10.775 44.4097 13.9988C41.1358 17.2226 38.2748 23.2899 42.2403 29.1478C42.2415 28.1733 42.2902 26.5221 43.3318 25.833C44.3734 25.1438 45.1357 24.8793 45.6033 25.1081L45.5967 25.1069Z"
          fill="black"
        />
        <path
          d="M54.4755 11.4911C54.7384 11.1012 54.7582 10.5627 54.5313 10.1479C54.3044 9.73308 53.836 9.47001 53.3739 9.36482C54.0605 8.81427 54.3308 7.8019 54.0082 6.9817C53.6857 6.16151 52.7989 5.60326 52.0136 5.90128C52.1645 5.39276 52.0483 4.81338 51.716 4.39704C51.3837 3.98069 50.8422 3.74565 50.5014 3.90037C50.3409 3.16663 49.7882 2.53086 49.0841 2.27061C48.3801 2.01036 47.5473 2.13302 47.2202 2.53895C46.4617 1.83288 45.3323 1.5489 44.3277 1.81512C43.3231 2.08135 42.4802 2.88046 42.2401 3.79928C41.583 3.40757 40.6981 3.43926 40.0667 3.87001C39.4353 4.30077 39.0906 5.116 39.1423 5.81012C38.4192 5.69649 37.6464 6.02056 37.2216 6.61378C36.7967 7.207 36.7378 8.04525 37.106 8.64513C36.5133 8.70099 35.9664 9.11596 35.7588 9.67584C35.5512 10.2357 35.6885 10.9074 36.2801 11.2842C35.6529 11.7293 35.4046 12.6365 35.7139 13.3385C36.0232 14.0405 36.8621 14.4642 37.632 14.1567C36.9969 14.6277 36.7571 15.5636 37.0905 16.2835C37.424 17.0033 38.286 17.4311 39.131 17.1811C39.1393 18.0244 39.6843 18.8394 40.4611 19.1704C41.2379 19.5014 42.2025 19.327 42.816 18.7465L54.4755 11.4911Z"
          fill="black"
        />
        <path
          d="M46.6572 25.2074C46.6095 21.4126 49.3565 16.7089 53.7174 15.8678C56.8577 15.2618 61.2095 15.111 64.318 17.0282C63.0993 14.3087 61.3443 12.7388 59.2049 12.3452C55.1782 11.6364 51.8408 11.8908 48.9116 13.9893C45.9824 16.0877 43.4533 20.6185 43.6716 25.3806C44.5091 24.9213 45.75 24.649 46.6605 25.208L46.6572 25.2074Z"
          fill="#FFB1B1"
        />
        <path
          d="M41.8953 49.1959L42.1224 45.7464C42.2001 44.5604 43.2251 43.6597 44.4132 43.7393L56.7738 44.5507C57.9599 44.6283 58.8607 45.6533 58.7811 46.8412L58.554 50.2907C58.4763 51.4767 57.4513 52.3774 56.2632 52.2978L43.9027 51.4864C42.7165 51.4088 41.8176 50.3839 41.8953 49.1959Z"
          fill="#FF6B6B"
        />
        <path
          d="M56.9391 50.2935C52.6041 50.3323 48.2671 49.9344 44.0117 49.1094"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9808 77.3438C30.4217 80.8572 29.7927 84.3688 29.2336 87.8823L27.8125 86.9408L28.0862 80.7544L30.9808 77.3438Z"
          fill="black"
        />
        <path
          d="M41.6133 48.5312C41.9996 52.9435 45.8668 56.7928 50.2833 57.1558C54.6999 57.5188 58.1807 54.1994 59.2814 49.9095"
          stroke="#FFB1B1"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M87.7539 108.897H33.1934V107.898C33.1934 106.073 34.6729 104.594 36.4976 104.594H87.7539V108.897Z"
          fill="black"
        />
        <path
          d="M66.5871 108.902H116.199L127.099 75.956C128.152 72.7721 125.781 69.4922 122.429 69.4922H83.1803C81.0585 69.4922 79.1768 70.8515 78.5106 72.8651L66.5871 108.902Z"
          fill="black"
        />
        <path
          d="M96.7298 90.6592C96.2865 88.7818 97.4492 86.9004 99.3268 86.4571C101.204 86.0138 103.086 87.1764 103.529 89.0538C103.973 90.9312 102.81 92.8125 100.932 93.2558C99.0547 93.6991 97.1732 92.5366 96.7298 90.6592Z"
          fill="white"
        />
        <path
          d="M100.159 93.9384C102.35 93.9384 104.133 92.1558 104.133 89.9652C104.133 87.7746 102.35 85.9922 100.159 85.9922C97.9685 85.9922 96.1858 87.7746 96.1858 89.9652C96.1888 92.1558 97.9685 93.9384 100.159 93.9384ZM100.159 86.9524C101.822 86.9524 103.175 88.3058 103.175 89.9683C103.175 91.6308 101.822 92.9841 100.159 92.9841C98.4967 92.9841 97.1432 91.6308 97.1432 89.9683C97.1462 88.3028 98.4967 86.9524 100.159 86.9524Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default GeniusNoAccessELASvg;
